import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    repaymentOptionHeading: {
        id: '_.duration_choice.radio_buttons.heading',
        defaultMessage: 'I want to repay over a maximum of'
    },
    monthlyRepaymentsDuration: {
        id: '_.duration_choice.radio_buttons.monthly_repayments_option',
        defaultMessage: '{months} monthly repayments'
    },
    repaymentAmount: {
        id: '_.duration_choice.radio_buttons.repayment_amount',
        defaultMessage: '(min. {amount} per month)'
    }
});
